export default __webpack_public_path__ + "static/media/accomm_img_2.b7689998.JPG";